import React from "react";
import { useForm } from "@refinedev/react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { FormField } from "@/components/ui/form-field";
import { EditPage } from "@/components/crud";
import { ICompany } from "../../types";

export const CompanyEdit: React.FC = () => {
  const {
    refineCore: { onFinish, formLoading },
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ICompany>();

  return (
    <EditPage>
      <form onSubmit={handleSubmit(onFinish)}>
        <Card>
          <CardHeader>
            <CardTitle>Company Information</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Company Name" required error={errors.name?.message as string}>
                <Input {...register("name", { required: "Please input the company name!" })} placeholder="Enter company name" />
              </FormField>
              <FormField label="Registration Number" required error={errors.registration_number?.message as string}>
                <Input {...register("registration_number", { required: "Please input the registration number!" })} placeholder="Enter registration number" />
              </FormField>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Tax Number">
                <Input {...register("tax_number")} placeholder="Enter tax number" />
              </FormField>
              <FormField label="Phone">
                <Input {...register("phone")} placeholder="Enter phone number" />
              </FormField>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <FormField label="Email" error={errors.email?.message as string}>
                <Input {...register("email", { pattern: { value: /^\S+@\S+$/i, message: "Please enter a valid email!" } })} placeholder="Enter email address" />
              </FormField>
              <FormField label="Website">
                <Input {...register("website")} placeholder="Enter website URL" />
              </FormField>
            </div>
            <FormField label="Address">
              <Textarea {...register("address")} rows={3} placeholder="Enter company address" />
            </FormField>
            <FormField label="Description">
              <Textarea {...register("description")} rows={4} placeholder="Enter company description" />
            </FormField>
          </CardContent>
        </Card>
        <div className="flex justify-end mt-6">
          <Button type="submit" disabled={formLoading}>Save</Button>
        </div>
      </form>
    </EditPage>
  );
};
